import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TourInformation } from 'src/app/interfaces/tour-information';

@Component({
  selector: 'app-filter-search-item',
  templateUrl: './filter-search-item.component.html',
  styleUrls: ['./filter-search-item.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgFor,
    NgIf,
    RouterLink
  ]
})
export class FilterSearchItemComponent {

  @Input() public itemData: TourInformation = {} as TourInformation
  
  constructor() {}

}
